import { render, staticRenderFns } from "./current-rates.vue?vue&type=template&id=7f3c4a85"
import script from "./current-rates.vue?vue&type=script&lang=js"
export * from "./current-rates.vue?vue&type=script&lang=js"
import style0 from "./current-rates.vue?vue&type=style&index=0&id=7f3c4a85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports